  export const POSITION_UNDER_HEADER = 1;
  export const POSITION_SIDEBAR = 2;
  export const POSITION_BETWEEN_POSTS = 4;
  export const POSITION_UNDER_FIRST_NEWS = 8;
  export const POSITION_SIDEBAR_SERIES = 16;
  export const POSITION_UNDER_POST = 32;
  export const POSITION_HOME_SIDEBAR = 64;